import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheckIcon } from 'lucide-react';
import { REFUND_POLICY } from '../config/site';
import { CTAButton } from './CTAButton';

/**
 * Sekcja gwarancji jest przygotowana, ale ukryta,
 * dopóki REFUND_POLICY.enabled nie zostanie ustawione na true
 * wraz z rzeczywistą polityką zwrotów.
 */
export function Guarantee() {
  if (!REFUND_POLICY.enabled) return null;
  return <section className="w-full bg-chem-soft/80 px-5 py-14 sm:py-20" data-id="element-180" data-mp="19fsgo9l83yf0">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true,
      amount: 0.2
    }} transition={{
      duration: 0.3,
      ease: [0.23, 1, 0.32, 1]
    }} className="mx-auto flex max-w-2xl flex-col items-center rounded-2xl border border-chem/30 bg-white p-8 text-center sm:p-12" data-id="element-181" data-mp="14g66ya4lt0ay">
        <span className="flex h-16 w-16 items-center justify-center rounded-full bg-chem/12 text-chem-deep" data-id="element-182" data-mp="qlwpv8yrffs0">
          <ShieldCheckIcon className="h-9 w-9" aria-hidden="true" data-id="element-183" data-mp="ozjd2ofk5ir9" />
        </span>
        <h2 className="mt-5 font-display text-2xl font-bold text-ink sm:text-3xl" data-id="element-184" data-mp="oxf9k7lkmlri">
          Gwarancja {REFUND_POLICY.days} dni
        </h2>
        <p className="mt-5 text-sm leading-relaxed text-ink/75 sm:text-base" data-id="element-185" data-mp="yot749typbi0">
          {REFUND_POLICY.text}
        </p>
        <div className="mt-8 w-full max-w-md" data-id="element-186" data-mp="12pmrwuc3ya6o">
          <CTAButton label="Uzyskaj natychmiastowy dostęp" data-id="element-187" data-mp="12sr7env0wscn" />
        </div>
      </motion.div>
    </section>;
}